// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"de01cf10","729":"5cfcc286"}[chunkId] + ".css";
};